import React from "react";

const steps = [
  {
    n: "01",
    title: "Create a tournament",
    desc: "Pick Americano or a Regular match. Choose format — best of 1, 3, 5 or 7 with optional Golden Point.",
  },
  {
    n: "02",
    title: "Add your players",
    desc: "Pull players from the community directory, or drop in guests. Rallie handles the rotation automatically.",
  },
  {
    n: "03",
    title: "Score live on court",
    desc: "Tap through 0-15-30-40, Deuce and Advantage. Rallie tracks sets, standings and stats in real time.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative py-20 md:py-24 border-t border-neutral-900 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src="https://images.unsplash.com/photo-1767128890583-b3f8dc30bdbc"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20">
          <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
            How it works
          </div>
          <h2
            data-testid="how-heading"
            className="font-display uppercase tracking-tight text-5xl md:text-7xl leading-[0.9] max-w-3xl"
          >
            Court to score
            <br />
            in three taps.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-4">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`how-step-${i + 1}`}
              className="relative border-t border-neutral-800 pt-8 pr-4"
            >
              <div className="font-display text-[6rem] md:text-[8rem] leading-none text-neutral-900 absolute -top-8 -left-2 select-none">
                {s.n}
              </div>
              <div className="relative">
                <div className="font-display uppercase text-2xl md:text-3xl tracking-tight mb-3">
                  {s.title}
                </div>
                <p className="text-neutral-400 text-sm md:text-base leading-relaxed max-w-sm">
                  {s.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
